import React from 'react';

const ScanToCad4 = () => {
  return (
    <section className="scan-tocad4-section">
      <div className="scan-tocad4-container">
        <h2 className="scan-tocad4-title">
          <span className="text-primary">What Is</span> Scan to CAD?
        </h2>
        <div className="scan-tocad4-content">
          <p>
            Scan to CAD is the process of converting laser scan or point cloud data into accurate 2D drawings or 3D CAD models. This allows project teams to work with existing site conditions in a clean, editable format instead of relying only on raw scan files.
          </p>
          <p>
            The service is widely used for renovation, restoration, retrofit planning, facility documentation, interior redesign, clash checking support, and existing-condition surveys. For clients who need dependable scan to AutoCAD services, this process transforms captured site data into practical deliverables that support faster planning and fewer site errors.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ScanToCad4;
